<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">When I register, it says I have the wrong item</h1>
			<p>
				Please take a screenshot of the error you are seeing, and we will review it with the publisher and your school
			</p>
			<div>
				<email-form
						subject="My code was not working"
						:body="email_body"
						on-success-url="/help?#/submitted"
						edit-body
						attach-screenshot
						require-screenshot
						destination-key="oq"
						:payload="{ order_line_id }"
				></email-form>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';
	import Axios from 'axios';

	export default {
		name: "WrongEbook",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				order_id: '',
				order_line_id: '',
			};
		},

		computed: {
			email_body() {
				return `My code was not working, the course says I have the wrong code but I bought what was listed for my class.`;
			}
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let d = response['data']['data'];
						self.order_id = d['order_id'];
						self.order_line_id = d['order_line_id'];
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},
	}
</script>

<style scoped>

</style>